<div class="overflow-y-auto height-without-bar lg:h-full">
  <div class="lg:hidden">
    <xplorer-bowser-mobile-header></xplorer-bowser-mobile-header>
  </div>
  <div class="lg:mt-40 ">
    <div class="container mx-auto px-0">
      <div class="px-[0.75rem]">
        <xplorer-bowser-hero></xplorer-bowser-hero>
      </div>

      <!-- TODO SPOSTARE TUTTO DENTRO IL COMPONENTE -->
      <div class="lg:mt-20">
        <div class="mb-6 md:mb-12 px-[0.75rem]">
          @if (loadingTitle) {
            <div
              class="mb-6 md:mb-12 w-48 h-8 lg:w-64 lg:h-10 2xl:w-72 2xl:h-12 bg-gray-300 rounded animate-pulse">
            </div>
            <div
              class="w-full no-scrollbar overflow-x-auto lg:overflow-x-hidden snap-mandatory snap-x flex flex-nowrap lg:grid lg:grid-cols-5 gap-[12px] lg:gap-6">
              @for (skeleton of skeletons; track $index) {
                <div
                  class="flex-none inline-flex items-end w-[120px] sm:w-[142px] md:w-[174px] lg:w-auto rounded-xl lg:rounded-3xl relative h-[213px] sm:h-64 md:h-72 lg:h-[18rem] xl:h-96 2xl:h-[31rem] overflow-hidden animate-pulse bg-gray-300 snap-center snap-always">
                  <div class="absolute inset-0 bg-gradient-to-b from-gray-300 to-gray-400"></div>
                  <div
                    class="relative z-10 w-full py-[1rem] px-[0.5rem] md:py-6 md:px-4 xl:py-12 xl:px-6">
                    <div class="mb-[0.5rem] lg:mb-[1rem] w-full h-6 lg:h-8 bg-gray-500 rounded"></div>
                    <div class="w-2/3 h-4 lg:h-6 bg-gray-500 rounded"></div>
                  </div>
                </div>
              }
            </div>
          } @else {
            <h2 class="text-black font-semibold text-[28px] lg:text-4xl 2xl:text-5xl">{{ sectionTitle }}
            </h2>
          }
        </div>

        @if (!loadingTitle) {
          <xplorer-bowser-close-destinations [allXploreItems]="allXploreItems" [loading]="loading">
          </xplorer-bowser-close-destinations>
        }
      </div>

      <!-- TODO SPOSTARE TUTTO DENTRO IL COMPONENTE -->
      <div class="mt-12 lg:mt-20 px-[0.75rem]">
        @if (isLoggedIn() && isLoadingUgcEligibility()) {
          <section class="mb-6 md:mb-8">
            <div class="rounded-[22px] border border-slate-200/80 bg-white/95 px-4 py-3 shadow-[0_20px_60px_-40px_rgba(15,23,42,0.45)]">
              <div class="flex items-center gap-3">
                <div class="h-10 w-10 animate-pulse rounded-2xl bg-slate-200"></div>
                <div class="min-w-0 flex-1">
                  <div class="h-3 w-20 animate-pulse rounded bg-slate-200"></div>
                  <div class="mt-2 h-5 w-1/2 animate-pulse rounded bg-slate-200"></div>
                </div>
              </div>
            </div>
          </section>
        }

        @if (ugcHomeAction(); as ugcHomeAction) {
          <section class="mb-5 md:mb-7">
            <a
              [routerLink]="ugcHomeAction.route"
              class="home-ugc-card"
              [class.home-ugc-card--create]="ugcHomeAction.mode === 'create'"
              [class.home-ugc-card--program]="ugcHomeAction.mode === 'program'">
              <img
                [src]="ugcHomeBackgroundImage"
                alt=""
                aria-hidden="true"
                loading="lazy"
                decoding="async"
                fetchpriority="low"
                class="home-ugc-card__background">
              <div class="home-ugc-card__scrim"></div>
              <div class="home-ugc-card__accent"></div>

              <div class="home-ugc-card__body">
                <div class="home-ugc-card__content">
                  <h2 class="home-ugc-card__title">
                    {{ ugcHomeAction.titleKey | translate }}
                  </h2>
                  <p class="home-ugc-card__subtitle">
                    {{ ugcHomeAction.subtitleKey | translate }}
                  </p>
                </div>

                <div class="home-ugc-card__actions">
                  <span class="home-ugc-card__cta">
                    {{ ugcHomeAction.ctaKey | translate }}
                  </span>

                  <span class="home-ugc-card__arrow">
                    <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" viewBox="0 0 24 24">
                      <path d="M5 12h14"></path>
                      <path d="m13 6 6 6-6 6"></path>
                    </svg>
                  </span>
                </div>
              </div>
            </a>
          </section>
        }

        <div class="mb-6 md:mb-12">
          <h2 class="text-black font-semibold text-[28px] lg:text-4xl 2xl:text-5xl">{{ 'home.our_territories'
            |
          translate }}</h2>
        </div>
        <xplorer-bowser-territory ngSkipHydration></xplorer-bowser-territory>
      </div>

      <!-- TODO SPOSTARE TUTTO DENTRO IL COMPONENTE -->
      <div class="mt-12 lg:mt-20 px-[0.75rem]">
        @if (!loadingFeaturedEvent && featuredEvent) {
          <div>
            <div class="mb-6 md:mb-12">
              <h2 class="text-black font-semibold text-[28px] lg:text-4xl 2xl:text-5xl">{{ 'home.featured' |
                translate }}
              </h2>
            </div>
            <xplorer-bowser-featured [event]="featuredEvent"></xplorer-bowser-featured>
          </div>
        }

        <!-- Skeleton Loader -->
        @if (loadingFeaturedEvent) {
          <div
            class="mb-6 md:mb-12 w-48 h-8 lg:w-64 lg:h-10 2xl:w-72 2xl:h-12 bg-gray-300 rounded animate-pulse">
          </div>
          <div
            class="w-full h-40 md:h-56 lg:h-96 bg-gray-300 rounded-xl lg:rounded-3xl overflow-hidden relative animate-pulse">
            <div
              class="w-full h-full object-cover absolute inset-0 bg-gradient-to-b from-gray-300 to-gray-400 rounded-xl lg:rounded-3xl">
            </div>
            <div
              class="relative z-10 flex items-center justify-center flex-col h-full gap-[0.5rem] lg:gap-6 py-[1rem] px-6">
              <div class="w-1/2 lg:w-1/4 h-8 md:h-10 lg:h-12 bg-gray-500 rounded mb-2 lg:mb-4"></div>
              <div class="w-1/3 lg:w-1/6 h-4 lg:h-6 bg-gray-500 rounded"></div>
            </div>
          </div>
        }
      </div>

      <div class="mt-12 pb-12 lg:mt-20 lg:pb-20">
        <div class="mb-6 md:mb-12 flex justify-between items-center px-[0.75rem]">
          <h2 class="text-black font-semibold text-[28px] lg:text-4xl 2xl:text-5xl">{{ 'home.categories' |
            translate
          }}</h2>
        </div>
        <xplorer-bowser-categories></xplorer-bowser-categories>
      </div>

      @if (seoSections.length > 0) {
        <section class="mt-6 lg:mt-8 pb-12 lg:pb-20 px-[0.75rem]">
          <h2 class="text-black font-semibold text-[28px] lg:text-4xl 2xl:text-5xl mb-6 md:mb-12">
            {{ seoSectionsTitle }}
          </h2>
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-[12px] lg:gap-6">
            @for (section of seoSections; track section) {
              <article
                class="bg-white border custom-border-color rounded-xl lg:rounded-3xl p-5 lg:p-8 shadow-sm">
                <h3 class="text-black font-semibold text-xl lg:text-2xl mb-3">{{ section.heading }}</h3>
                <p class="text-theme-body text-sm lg:text-base leading-relaxed mb-4">{{ section.body }}</p>
                @if (section.ctaRoute) {
                  <a [routerLink]="section.ctaRoute"
                    class="inline-flex text-sm lg:text-base font-semibold custom-base-color hover:underline">
                    {{ section.ctaLabel }}
                  </a>
                }
              </article>
            }
          </div>
          <div class="mt-8">
            <a [href]="parentDomainUrl" rel="noopener noreferrer"
              class="text-sm lg:text-base font-semibold custom-base-color hover:underline">
              {{ parentDomainLabel }}
            </a>
          </div>
        </section>
      }
    </div>
  </div>

</div>
